/**
 * Bounds for all surgical act parameters.
 * All 4 frontend components import from here — no inline numeric bounds in components.
 */
export const SURGICAL_ACT_LIMITS = {
  GLOBAL_ALIGNMENT: {
    LUMBAR_LORDOSIS_PI_DELTA: 30, // range = [PI-30, PI+30]
    SACRAL_SLOPE: { min: 15, max: 70 },
    GLOBAL_TILT: { min: 0, max: 90 },
    PELVIC_TILT: { min: 0, max: 45 },
    TARGET_PELVIC_TILT: { min: 0, max: 45 },
    PI_LL: { min: -30, max: 30 },
    T1PA: { min: 0, max: 60 },
    KNEE_ANGLE: { min: -10, max: 60 },
  },
  OSTEOTOMY: {
    MIN: 0,
    GRADE_1_MAX: 15,
    GRADE_2_MAX: 20,
    GRADE_3_MAX: 180,
    GRADE_4_MAX: 180,
  },
  SEGMENTAL_TRANSFORMATION: {
    ROTATION: { min: -30, max: 30 },
    TRANSLATION: { min: -75, max: 75 },
  },
  CAGE: {
    ANGLE: { min: -60, max: 60 },
  },
};
